import { classeColorePerc } from "../inc/inc";

export default function Comp(props) {
  let percentOkDisplay =
    !props.percentualeOk || props.percentualeOk < 5.8
      ? 5.8
      : props.percentualeOk;
  // let percentNoDisplay = (!props.percentualeNo ||  props.percentualeNo < 5.8) ? 5.8 : props.percentualeNo;

  return (
    <div className="graficoPDF noBreak">
      <div
        style={{ display: "flex", alignItems: "stretch" }}
        className="graficoTotal"
      >
        <div style={{ width: "66%" }} className="graficoTotal1">
          <h2 style={{ marginTop: 0, paddingLeft: 0, fontSize: 30 }} className="maiuscF">{props.nomeSezione}</h2>
          <div className="elemGrafico">
            <div
              className="innerGrafico"
              style={{
                // backgroundColor: props.colore,
                backgroundColor: "#444",
                width: percentOkDisplay + "%",
              }}
            ></div>
          </div>
          <p className="maiuscF"> </p>

        </div>
        <div
          className={
            "percentuale percentuale " + classeColorePerc(props.percentualeOk)
          }
          style={{ flexGrow: 1 }}
        >
          <div>
            <small className="maiuscF" style={{ fontSize: 30 }}>Punteggio %</small> <br />
            <span style={{ fontSize: "1.7em" }}>{props.percentualeOk + "%"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
